import { GridContainer, GridItem } from '@entur/grid';
import StatusDropdown from 'components/Dropdowns/StatusDropdown';
import ClearTextField from 'components/TextFields/ClearTextField';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { TransactionTypeDto } from 'types';

interface TransactionTypeFormProps {
  formContext: UseFormReturn<TransactionTypeDto>;
  mode?: 'create' | 'edit' | 'view';
}

export const TransactionTypeForm = ({ formContext, mode = 'view' }: TransactionTypeFormProps) => {
  const intl = useIntl();
  const {
    register,
    control,
    formState: { errors },
  } = formContext;

  return (
    <GridContainer spacing="small">
      <GridItem small={4}>
        <ClearTextField
          {...register('name', {
            required: {
              value: true,
              message: intl.formatMessage({ id: 'warnings.inputCannotBeEmpty' }),
            },
            maxLength: { value: 80, message: intl.formatMessage({ id: 'warnings.maxLength' }, { number: 80 }) },
          })}
          readOnly={mode === 'view'}
          required={mode !== 'view'}
          variant={errors.name ? 'error' : 'information'}
          label={intl.formatMessage({ id: 'generalValues.name' })}
          feedback={errors.name?.message}
          autoComplete="off"
        />
      </GridItem>
      <GridItem small={4}>
        <ClearTextField
          {...register('type', {
            required: {
              value: true,
              message: intl.formatMessage({ id: 'warnings.inputCannotBeEmpty' }),
            },
            maxLength: { value: 30, message: intl.formatMessage({ id: 'warnings.maxLength' }, { number: 30 }) },
            pattern: {
              value: /^[A-Z_]+$/,
              message: intl.formatMessage({ id: 'warnings.upperCaseUnderscore' }),
            },
          })}
          readOnly={mode !== 'create'}
          required={mode !== 'view'}
          variant={errors.type ? 'error' : 'information'}
          label={intl.formatMessage({ id: 'generalValues.type' })}
          feedback={errors.type?.message}
          autoComplete="off"
        />
      </GridItem>
      <GridItem small={4}>
        <Controller
          name="status"
          control={control}
          rules={{
            required: {
              value: true,
              message: intl.formatMessage({ id: 'warnings.inputCannotBeEmpty' }),
            },
          }}
          render={({ field: { value, onChange, ...field } }) => (
            <StatusDropdown
              {...field}
              readonly={mode === 'view'}
              selectedItem={value?.toString()}
              onChangeStatus={(item) => {
                onChange(item?.value);
              }}
              variant={errors.status ? 'error' : 'info'}
              feedback={errors.status?.message}
              required
              isCreateMode={mode === 'create'}
            />
          )}
        />
      </GridItem>
    </GridContainer>
  );
};
